'use client'
import { Button, Image } from '@heroui/react'
import img_not_found from '@/assets/images/not_found.webp'
import { useRouter } from 'next/navigation'

export default function NotFound() {
  // TODO: Fix the style of this page

  const router = useRouter()

  const handleBack = () => {
    router.back()
  }

  return (
    <div className="relative w-full min-h-screen bg-[rgba(0,0,0,0.5)]">
      <div className="h-screem">
        <Image
          alt="Not Found"
          src={img_not_found.src}
          className="w-full  h-screen min-h-screen object-cover -z-20 rounded-none"
          removeWrapper
        />
      </div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-white w-full">
        <h1 className="text-4xl font-bold mb-4">Página no encontrada</h1>
        <Button
          variant="ghost"
          className="text-white border-white border-1"
          onPress={handleBack}
        >
          Volver atrás
        </Button>
      </div>
    </div>
  )
}
